import React from "react";
import Text from "@amzn/meridian/text";
import { FormattedMessage, injectIntl } from "react-intl";
import useContextStore from "../../../stores/ContextStore";
import { MobileDisplay } from "../../common/MobileDisplay";
import Column from "@amzn/meridian/column";
import { SPACING_MEDIUM } from "../../common/constant/ResponsiveProps";
function Header() {
  const username = useContextStore((state) => state.username);
  return (
    <Column spacing={"none"}>
      <MobileDisplay visibility={true}>
        <Text type={"h100"} spacingTop={SPACING_MEDIUM} color={"secondary"}>
          <FormattedMessage
            id="overview.workitems.tabName"
            defaultMessage="Work Items"
          />
        </Text>
      </MobileDisplay>
      <Text type="h600">
        <FormattedMessage id="overview.header.hi" defaultMessage="Hi" />
        &nbsp;
        {username}
      </Text>
      <MobileDisplay visibility={false}>
        <Text color="secondary">
          <FormattedMessage
            id="overview.header.hereAreTheWorkItemsForToday"
            defaultMessage="Here are the work items for today and any pending tasks from previous days"
          />
        </Text>
      </MobileDisplay>
    </Column>
  );
}
export default injectIntl(Header);



// WEBPACK FOOTER //
// ./src/components/overview/Header/Header.jsx